const metadata = (globalThis as typeof globalThis & {
  __blankmileBuild: { buildEnvironment: string; buildDate: string; commitHash: string };
}).__blankmileBuild;
export const buildEnvironment = metadata.buildEnvironment;
export const buildDate = metadata.buildDate;
export const commitHash = metadata.commitHash;
